export default "__VITE_ASSET__514e3e10__"